import { render, staticRenderFns } from "./GroupSelectedItems.vue?vue&type=template&id=72e86484&scoped=true&"
import script from "./GroupSelectedItems.vue?vue&type=script&lang=js&"
export * from "./GroupSelectedItems.vue?vue&type=script&lang=js&"
import style0 from "./GroupSelectedItems.vue?vue&type=style&index=0&id=72e86484&lang=scss&scoped=true&"
import style1 from "./GroupSelectedItems.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./GroupSelectedItems.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e86484",
  null
  
)

export default component.exports